
import { Dispatch } from "@reduxjs/toolkit";
import { RootState } from "../../../app/store";
import { GraphThingyActions } from "../actions/actions";
import {graphdata} from "../typing/typing";
import { myfetchThunk } from "../../../app/myfetch";
import {masteruri} from "../../../config";


interface testdataResponsePayloadInterface{
    data:{
    user:graphdata[],
    }
}

export const requestDataFromAPI =() => {
    return (
        dispatch:Dispatch<any>, 
        getState:() => RootState
    )=>{       
        dispatch(myfetchThunk(
            true,
            masteruri+"/Vulnerabilities/grouping",
            {},
            "GET",
            (payload:testdataResponsePayloadInterface) => {
                console.log(payload);
                
                dispatch(
                    GraphThingyActions.resetData(
                         {
                             data : payload.data.user,
                         }
                     )
                 );
            },
            ()=>{}
        ) as any)
    }
}